// The fields with these names will be reset to an empty string when the country selection is changes in the users form.
export const FIELDS_TO_RESET_UPON_COUNTRY_CHANGE = [
    'regionAbbr',
    'userZipcode',
    'userPhoneNumber',
];

export const PROPERTIES_PER_PAGE = 10;
